export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 12 11" fill="none">
    <path d="M10.999 0.600098L1.14062 10.4584L10.999 0.600098Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M10.8583 10.4584L1 0.600098L10.8583 10.4584Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
)
